var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3814 13.7889V8.44869C49.3814 6.68065 47.9742 5.27344 46.2062 5.27344H15.1753C13.4072 5.27344 12 6.68065 12 8.44869V13.7889V49.4023C12 51.1703 13.4072 52.5776 15.1753 52.5776H64.8247C66.5928 52.5776 68 51.1703 68 49.4023V16.9642C68 15.1961 66.5928 13.7889 64.8247 13.7889H49.3814Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2419 21.2578L39.9997 27.5001L33.7213 21.2578L29.9688 25.0104L36.211 31.2887L29.9688 37.531L33.7213 41.3197L39.9997 35.0413L46.2419 41.3197L49.9945 37.531L43.7523 31.2887L49.9945 25.0104L46.2419 21.2578Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.9b59d73279415028a70de25dd6fb73a3.svg";
export { ForwardRef as ReactComponent };